import { Skeleton } from "~/components/ui/skeleton";

/**
 * Skeleton for the PDP info column (name, brand link, SKU, ratings,
 * short description, price, variant selectors, qty stepper, ATC).
 *
 * Sized to mirror the final markup in product-details.tsx L371-519 so
 * the column doesn't reflow when the awaited product resolves.
 */
export const InfoColumnSkeleton = () => {
  return (
    <div className="info-column-skeleton relative flex w-full flex-col gap-3 px-5 sm:px-0">
      {/* Common: name, brand, SKU, ratings, description */}
      <div className="space-y-3">
        {/* Title + brand are hoisted above the image on mobile (resolved
            column does the same); reserve them in-column at md+ only. */}
        <div className="min-[768px]:flex min-[768px]:flex-col min-[768px]:gap-3 hidden">
          {/* h1 — name (1-2 lines, ~text-xl/2xl + font-grotesque) */}
          <div className="space-y-2">
            <Skeleton className="h-7 w-4/5 md:h-8" />
            <Skeleton className="h-7 w-3/5 md:h-8" />
          </div>
          {/* Brand link row */}
          <Skeleton className="h-4 w-40" />
        </div>
        {/* SKU line */}
        <Skeleton className="h-3 w-24" />
        {/* Ratings row */}
        <Skeleton className="h-5 w-32" />
        {/* Short description (3 lines + "Read More") */}
        <div className="space-y-1.5 pt-1">
          <Skeleton className="h-3.5 w-full" />
          <Skeleton className="h-3.5 w-full" />
          <Skeleton className="h-3.5 w-2/3" />
          <Skeleton className="h-3.5 w-20" />
        </div>
      </div>

      {/* Price */}
      <div className="pt-1">
        <Skeleton className="h-8 w-28" />
      </div>

      {/* Variant swatch rows (typical: size + color) */}
      <div className="space-y-2 pt-2">
        <Skeleton className="h-4 w-20" />
        <div className="flex flex-wrap gap-2">
          {Array.from({ length: 4 }).map((_, i) => (
            <Skeleton key={`v1-${i}`} className="h-9 w-9 rounded" />
          ))}
        </div>
      </div>

      {/* Qty stepper + ATC button */}
      <div className="flex items-stretch gap-2 pt-2">
        <Skeleton className="h-11 w-24" />
        <Skeleton className="h-11 flex-1" />
      </div>
    </div>
  );
};
